import { useState } from "react";
import PageWrapper from "../../common/components/PageWrapper";
import { ArrowLeftIcon } from "@heroicons/react/24/outline";
import { twMerge } from "tailwind-merge";
import BlackOverlay from "../components/BlackOverlay";
import NetworkDetails from "../components/NetworkDetails";
import NetworkList from "../components/NetworkList";
import { UserType } from "global";

export type NetworkOwner = {
  id: string | null;
  type: UserType | null;
};

export default function NetworkListContainer() {
  const [owner, setOwner] = useState<NetworkOwner>({
    id: null,
    type: null,
  });

  const isOwnerSelected = !!owner.id && !!owner.type;

  return (
    <PageWrapper className="flex-row">
      <NetworkList ownerId={owner.id} onOwnerSelect={setOwner} />
      <div
        className={twMerge(
          "relative flex h-full w-1/6 flex-shrink-0 flex-col gap-3 transition-all duration-300",
          isOwnerSelected && "w-5/6 overflow-auto"
        )}
      >
        <BlackOverlay
          isShown={!isOwnerSelected}
          message={"네트워크를\n선택해 주세요"}
          icon={<ArrowLeftIcon className="h-8 w-8" />}
        />
        <NetworkDetails owner={owner} onOwnerSelect={setOwner} />
      </div>
    </PageWrapper>
  );
}
